'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var multiaddr = require('multiaddr');

var objectToCamel = require('../lib/object-to-camel.js');

var configure = require('../lib/configure.js');

var toUrlSearchParams = require('../lib/to-url-search-params.js');

var createProvide = configure.configure(function (api) {
  function provide(_x) {
    return _provide.apply(this, arguments);
  }

  function _provide() {
    _provide = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cids) {
      var options,
          cidArr,
          res,
          _iteratorAbruptCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          message,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {
                recursive: false
              };
              cidArr = Array.isArray(cids) ? cids : [cids];
              _context.next = 4;
              return _awaitAsyncGenerator(api.post('dht/provide', {
                signal: options.signal,
                searchParams: toUrlSearchParams.toUrlSearchParams(_objectSpread({
                  arg: cidArr.map(function (cid) {
                    return cid.toString();
                  })
                }, options)),
                headers: options.headers
              }));

            case 4:
              res = _context.sent;
              _iteratorAbruptCompletion = false;
              _didIteratorError = false;
              _context.prev = 7;
              _iterator = _asyncIterator(res.ndjson());

            case 9:
              _context.next = 11;
              return _awaitAsyncGenerator(_iterator.next());

            case 11:
              if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                _context.next = 20;
                break;
              }

              message = _step.value;
              message = objectToCamel.objectToCamel(message);

              if (message.responses) {
                message.responses = message.responses.map(function (_ref) {
                  var ID = _ref.ID,
                      Addrs = _ref.Addrs;
                  return {
                    id: ID,
                    addrs: (Addrs || []).map(function (a) {
                      return new multiaddr.Multiaddr(a);
                    })
                  };
                });
              } else {
                message.responses = [];
              }

              _context.next = 17;
              return message;

            case 17:
              _iteratorAbruptCompletion = false;
              _context.next = 9;
              break;

            case 20:
              _context.next = 26;
              break;

            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](7);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 26:
              _context.prev = 26;
              _context.prev = 27;

              if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                _context.next = 31;
                break;
              }

              _context.next = 31;
              return _awaitAsyncGenerator(_iterator.return());

            case 31:
              _context.prev = 31;

              if (!_didIteratorError) {
                _context.next = 34;
                break;
              }

              throw _iteratorError;

            case 34:
              return _context.finish(31);

            case 35:
              return _context.finish(26);

            case 36:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[7, 22, 26, 36], [27,, 31, 35]]);
    }));
    return _provide.apply(this, arguments);
  }

  return provide;
});
exports.createProvide = createProvide;